export enum SelectMode {
    'single',
    'multi',
    'os',
    'fire&forget'
}